/* The meow button (packages/client/src/meow.js).  Bottom-right, a panel's height above
   #look-hint -- the corners are spoken for (#keys left, the hint right)
   and this is the one clickable thing on an edge of
   read-outs, so it borrows #open-customizer's accent-pill treatment: that
   is the page's one established "this panel is a button" idiom.  Hidden
   with the other desktop affordances on touch, where the pad in #pads
   replaces it; :active gives the click itself a flash of feedback even
   though the real feedback is the cat. */
#meow-btn{right:16px;bottom:54px;z-index:3;
  font-family:inherit;font-size:.68rem;letter-spacing:.05em;padding:8px 13px;
  color:var(--accent);cursor:pointer;pointer-events:auto;
  transition:color .15s,border-color .15s,background .15s}
#meow-btn:hover{background:var(--accent);border-color:var(--accent);color:#171812}
#meow-btn:active{transform:translateY(1px)}
#meow-btn:focus-visible{outline:2px solid var(--accent);outline-offset:2px}
html.touch #meow-btn{display:none}
